<template>
    <v-app id="inspire">
        <v-content>
            <v-container fluid fill-height v-if="background != null" v-bind:style="{ 'background-image': 'url(' + background + ')' }" class="bg-container">
                <router-view></router-view>
            </v-container>
            <v-container fluid fill-height v-else class="bg-container">
                <router-view></router-view>
            </v-container>
        </v-content>

        <v-overlay :value="overlay">
            <Maintain />
        </v-overlay>
    </v-app>
</template>

<script>
    import {IS_MAINTAIN} from "~/config";
    import Maintain from "~/components/Maintain";
    import {CONFIG_PAGE} from "~/store/actions.type";
    export default {
        components: {
            Maintain
        },
        data() {
            return {
                overlay: IS_MAINTAIN,
                background: null
            };
        },
        async beforeCreate() {
            this.$store.dispatch(CONFIG_PAGE).then(data => {
                let appName = data.filter(o => o.key == 'key_cp_app_name');
                let appBackground = data.filter(o => o.key == 'key_cp_background');
                if (appName[0]['value'] != undefined && appName[0]['status']) {
                    this.appName = appName[0]['value'];
                    localStorage.setItem('appName', this.appName)
                }
                if (appBackground[0]['value'] != undefined && appBackground[0]['status']) {
                    localStorage.setItem('appBackground', appBackground[0]['value'])
                    this.background = "'" + appBackground[0]['value'] + "'"
                }
            })

        }

    };
</script>
<style lang="scss" scoped>
    .bg-container {
        background-image: url("../../asserts/amaiteam.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
</style>
